export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    slug: 'official-access',
    name: '官方入口地址',
    description: '蘑菇TV最新官方入口地址汇总，确保您第一时间访问到官方正版平台，享受稳定流畅的观看体验。',
    icon: 'ri-link',
    articleCount: 8,
  },
  {
    slug: 'backup-access',
    name: '备用访问入口',
    description: '当官方入口不稳定或无法访问时，备用入口帮您快速连接蘑菇TV，不错过任何精彩内容。',
    icon: 'ri-shield-check-line',
    articleCount: 6,
  },
  {
    slug: 'usage-guides',
    name: '使用教程指南',
    description: '从注册到观看，详细的蘑菇TV使用教程，帮助新用户快速上手，老用户发现隐藏功能。',
    icon: 'ri-book-open-line',
    articleCount: 10,
  },
  {
    slug: 'faq-solutions',
    name: '常见问题解答',
    description: '收集用户最常遇到的问题及解决方案，包括加载失败、黑屏、卡顿等问题的排查方法。',
    icon: 'ri-question-answer-line',
    articleCount: 12,
  },
  {
    slug: 'latest-news',
    name: '最新动态资讯',
    description: '蘑菇TV平台最新动态、功能更新、活动通知等内容，让您始终掌握第一手信息。',
    icon: 'ri-newspaper-line',
    articleCount: 5,
  },
];

export const categoryMap: Record<string, Category> = {};
categories.forEach((cat) => {
  categoryMap[cat.slug] = cat;
});